import { Link } from 'react-router-dom';
import { Building2, ArrowRight } from 'lucide-react';
import AppHeader from '../components/AppHeader';
import { Button } from '../components/ui/button';

/**
 * Friendly wall for students who land on /listings/new. We don't want to
 * silently 403 — we tell them why and point them at the landlord path.
 */
const LandlordOnly = () => (
  <div className="min-h-screen bg-background flex flex-col" data-testid="landlord-only">
    <AppHeader />
    <main className="flex-1 px-5 py-12 sm:py-20">
      <div className="max-w-md mx-auto text-center">
        <div className="mx-auto w-16 h-16 bg-amber-100 rounded-2xl flex items-center justify-center mb-5">
          <Building2 className="h-8 w-8 text-amber-600" />
        </div>
        <h1 className="text-2xl sm:text-3xl font-heading font-extrabold text-slate-900 leading-tight">
          This area is for landlords.
        </h1>
        <p className="mt-3 text-base text-slate-600 leading-relaxed">
          Students search and save homes here. If you're a landlord looking to list a place,
          we'd love to verify you and get you started.
        </p>
        <Button
          asChild
          className="mt-6 btn-primary"
          data-testid="landlord-only-signup-cta"
        >
          <Link to="/signup?role=landlord">
            Sign up as a landlord
            <ArrowRight className="h-4 w-4 ml-2" />
          </Link>
        </Button>
      </div>
    </main>
  </div>
);

export default LandlordOnly;
